import * as angular from 'angular';
import './article-edit-modal.component.css';

const template = `
    <mw-mini-modal-dialog 
        class="mw-mini-modal-dialog mw-mini-modal--wide article-edit-modal" 
        layout="column"
        flex  
        ok="{{'Apply'|translate}}" 
        cancel="{{'Cancel'|translate}}" 
        on-ok="$ctrl.handleOk($event)" 
        on-cancel="$ctrl.handleCancel($event)"> 
        <mw-modal-header  layout="row" layout-align="center center" flex>
            <mw-modal-header-title translate>Edit Article</mw-modal-header-title>
            <mw-infotip text-content="{{'article-edit-modal__header-tooltip-text'|translate}}"></mw-infotip> 
            <div flex=""></div>
        </mw-modal-header>
        <mw-modal-alert-message layout="column" ng-if="$ctrl.shouldValidateForm"> 
            {{'app__form-messaging--please-review'|translate}}
        </mw-modal-alert-message> 
        <mw-modal-content> 
            <ng-form name="$ctrl.articleEditForm" layout="column"> 
               
                <md-input-container ng-if="$ctrl.isEditorial($ctrl.model)"> 
                    <label translate>Title</label>
                    <input name="title" ng-model="$ctrl.model.title" required="" maxlength="280" md-maxlength="280" /> 
                    <div class="md-errors-spacer"></div> 
                    <div ng-messages="$ctrl.articleEditForm.title.$error"> 
                        <div ng-message="required" translate>app__form-messaging--required-field</div> 
                    </div> 
                </md-input-container>  
                                
                <md-input-container class="article-edit-input-container-margin" ng-if="$ctrl.isEditorial($ctrl.model)"> 
                    <label translate>Opening Text</label>
                    <textarea ng-model="$ctrl.model.ingress" name="articleSummary" maxlength="1000" md-maxlength="1000"></textarea> 
                </md-input-container>  
                
                <md-input-container>
                    <label class="md-no-float" translate>Comment</label>
                    <mw-tinymce-wrapper content="$ctrl.model.comment" options="$ctrl.tinymceOption"></mw-tinymce-wrapper>
                </md-input-container>
            </ng-form> 
        </mw-modal-content> 
        <mw-modal-footer layout="row" layout-align="center center" flex>
            <md-checkbox 
                class="md-primary"
                ng-if="$ctrl.isEditorial($ctrl.model, $ctrl.enableAddedContentEdition)"
                ng-disabled="!$ctrl.shouldShowTnC()"
                ng-model="$ctrl.termsAndConditionsAcknowledged">
                    <span ng-bind-html="$ctrl.tncText" class="article-edit-modal__tnc-text"></span>
            </md-checkbox>
            <div flex=""></div>
            <md-button ng-click="$ctrl.handleCancel($event)" class="mw-mini-modal__cancel-button mw-button" translate>Cancel</md-button>
            <md-button ng-click="$ctrl.handleOk($event)" class="mw-mini-modal__ok-button mw-button" ng-disabled="!$ctrl.isOkEnabled()" style="padding: 0 12px" translate>Apply</md-button>
        </mw-modal-footer>
    </mw-mini-modal-dialog>
`;

const articleEditModalConfig = {
    selector: 'mwArticleEditModal',
    bindings: {
        article: '<'
    },
    template: template,
    controller: null
};

class ArticleEditModalComponent {
    model: any;
    article: any;
    articleEditForm: any;
    spamLawText: string;
    tncText: string;
    tinymceOption: any;
    termsAndConditionsAcknowledged: boolean = false;

    constructor(
        private CoreUserService,
        private $mdDialog,
        private $translate,
        private $timeout) {
        'ngInject';

        let templateFontLabel = this.$translate.instant('article-edit-modal__template-font-label');

        this.tinymceOption = {
            limit: 3000,
            font_formats: templateFontLabel +'=inherit;Sans Serif=helvetica,sans-serif;Serif=times new roman,times,serif;Fixed Width=monospace;Comic Sans MS=comic sans ms,sans-serif;Garamond=garamond,serif;Georgia=georgia,serif;Tahoma=tahoma,arial,helvetica,sans-serif;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva',
            fontsize_formats: 'inherit 10px 11px 12px 13px 14px 15px 16px 18px 24px 36px',
            defaultFontName: 'inherit',
            defaultFontSize: 'inherit'
        }
    }

    sanitizeInput(input) {
        return sanitizeHtml(input, {
            allowedTags: [],
            allowedAttributes: {}
        });
    }

    initTermsLine() {
        this.tncText = this.$translate.instant('article-edit-modal__terms-and-conditions-checkbox-label', {
            openingTag: '<a class="tnc-link" href="">',
            closingTag: '</a>'
        }).replace(/&gt;/g, '>').replace(/&lt;/g, '<');

        // Using timeout to hold execution for DOM rendering
        this.$timeout(() => {
            'ngInject';
            let $scope, $injector;
            // Grab the anchor tag and make into an angular element, add ng-click to it
            let el = angular.element(document.getElementsByClassName('tnc-link')[0]);
            el.attr('ng-click', '$event.stopPropagation()');

            // Create the tooltip element and append to the anchor element
            let tooltip = angular.element(`<md-tooltip md-direction="top" class="mw-infotip">{{'article-edit-modal__terms-and-conditions-text'|translate}}</md-tooltip>`);
            el.append(tooltip);

            // Compile
            $scope = el.scope();
            $injector = el.injector();
            $injector.invoke(function ($compile) {
                $compile(el)($scope)
            })
        });
    }

    isEditorial(article) {
        return article && article.informationType === 'news' && article.sourceId.indexOf('rss:') === -1;
    };

    titleHasChanged() {
        return this.sanitizeInput(this.article.title) !== this.sanitizeInput(this.model.title);
    }

    openingTextHasChanged() {
        return (!this.model.ingress && !this.article.ingress) ? false : this.sanitizeInput(this.article.ingress) !== this.sanitizeInput(this.model.ingress);
    }

    shouldShowTnC() {
        return this.isEditorial(this.article) && (this.titleHasChanged() || this.openingTextHasChanged());
    }

    isOkEnabled() {
        return !this.isEditorial(this.article)
            || (this.articleEditForm.$valid && this.termsAndConditionsAcknowledged)
            || (!this.titleHasChanged() && !this.openingTextHasChanged());
    }

    handleOk() {
        this.model.ingress = this.sanitizeInput(this.model.ingress);
        this.model.title = this.sanitizeInput(this.model.title);
        this.$mdDialog.hide(this.model);
    }

    handleCancel() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        if (this.isEditorial(this.article)) {
            this.initTermsLine();
        }

        this.model = angular.copy(this.article);
        this.model.comment = this.article.comment || '';
        this.model.ingress = this.model.ingress ? this.sanitizeInput(this.model.ingress) : '';

        this.tinymceOption.language = this.CoreUserService.getLanguage() || 'en';
    }
}

articleEditModalConfig.controller = ArticleEditModalComponent;

export {
    articleEditModalConfig,
    ArticleEditModalComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/articles/article-edit-modal/article-edit-modal.component.ts
 **/